import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { MegaStore, singleTransaction } from '@wix/thunderbolt-catharsis'
import {
	stringifyAllComponentsCss,
	getComponentsCss,
	componentCssFeaturesProvider,
	viewerCssFeatures,
} from '@wix/thunderbolt-catharsis-extensions'
import _ from 'lodash'
import { createCatharisArgs } from './createCatharisArgs'

export const getCatharsisCss = (beckyModel: BeckyModel): MegaStore | null => {
	const { componentNodes, usedDataMaps } = componentCssFeaturesProvider(
		viewerCssFeatures,
		(exp) => !!beckyModel.experiments[exp]
	)

	if (usedDataMaps.size === 0) {
		return null
	}

	const catharsisMegaStore = new MegaStore()
	const catharsisArgs = createCatharisArgs(catharsisMegaStore, componentNodes)

	singleTransaction(beckyModel, catharsisArgs, usedDataMaps)

	return catharsisMegaStore
}

export const getCatharsisCssString = (beckyModel: BeckyModel): string => {
	const catharsisMegaStore = getCatharsisCss(beckyModel)

	if (!catharsisMegaStore) {
		return ''
	}

	const componentsCss = stringifyAllComponentsCss(
		getComponentsCss(catharsisMegaStore, beckyModel.structure, beckyModel.pageCompId, beckyModel.experiments)
	)

	const allFontFacesCss = catharsisMegaStore.getById<Record<string, Array<string>>>('fontFacesCss')

	const fontsCss = _(allFontFacesCss)
		.flatMap((fontFacesCss) => fontFacesCss)
		.uniq()
		.value()

	return [
		/* catharsis font faces */
		...fontsCss,
		/* catharsis components css */
		componentsCss,
	].join('\n')
}
